var labels = {
  assign_all: {
    es: 'Asignar todos',
    en: 'Assign all'
  },
  accept_requests: {
    es: 'Aceptar solicitudes',
    en: 'Accept requests'
  },
  filter: {
    es: 'Filtrar',
    en: 'Filter'
  },
  search: {
    es: 'Buscar',
    en: 'Search'
  },
  clean: {
    es: 'Limpiar',
    en: 'Clean'
  },
  download_metadata: {
    es: 'Descargar metadata',
    en: 'Download metadata'
  },
  request: {
    es: 'Solicitar',
    en: 'Request'
  },
  cancel: {
    es: 'Cancelar',
    en: 'Cancel'
  },
  assign: {
    es: 'Asignar',
    en: 'Assign'
  },
  accept: {
    es: 'Aceptar',
    en: 'Accept'
  },
  see_all: {
    es: 'Ver todas',
    en: 'See all'
  },
  reject: {
    es: 'Rechazar',
    en: 'Reject'
  },
  approve_automatic: {
    es: 'Aprobación automática',
    en: 'Automatic approval'
  },
  accept_reject: {
    es: 'Aceptar/Rechazar',
    en: 'Accept/Reject'
  },
  save: {
    es: 'Guardar',
    en: 'Save'
  },
  back: {
    es: 'Volver',
    en: 'Back'
  },
  preview: {
    es: 'Previsualizar',
    en: 'Preview'
  },
  close: {
    es: 'Cerrar',
    en: 'Close'
  },
  ok: {
    es: 'Ok',
    en: 'Ok'
  },
  refresh: {
    es: 'Refrescar',
    en: 'Refresh'
  },
  remove_item: {
    es: 'Eliminar item',
    en: 'Remove item'
  },
  add_item: {
    es: 'Añadir item',
    en: 'Add item'
  },
  add_table: {
    es: 'Añadir tabla',
    en: 'Add table'
  },
  download: {
    es: 'Descargar',
    en: 'Download'
  },
  confirm: {
    es: 'Confirmar',
    en: 'Confirm'
  },
  reset: {
    es: 'Reiniciar',
    en: 'Reset'
  },
  update: {
    es: 'Actualizar',
    en: 'Update'
  },
  create: {
    es: 'Crear',
    en: 'Create'
  },
  sync: {
    es: 'Sincronizar',
    en: 'Sync'
  },
  previous: {
    es: 'Anterior',
    en: 'Previous'
  }
};
export default labels;